import { ITopList } from '@epicuro-next/data/reporting-api';
import { IUser } from '@epicuro-next/data/users';

import { BestPerformingList, BestPerformingListOwner } from '../../models';

export function mapTopListsToOwners(
  topLists: ITopList[],
  owners: IUser[],
): BestPerformingList[] {
  const ownersMapper = owners.map<[string, BestPerformingListOwner]>(
    (owner) => [owner.externalId, extractPartialUserInfo(owner)],
  );
  const ownersMap = new Map(ownersMapper);

  return topLists.map((list) => ({
    topListInfo: list,
    ownerInfo: ownersMap.get(list.ownerId ?? ''),
  }));
}

function extractPartialUserInfo(user: IUser) {
  const { externalId, displayName, email, imageLink } = user;
  return { externalId, displayName, email, imageLink };
}
